// graph.js
export async function callMsGraph(accessToken: any, endpoint: any) {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${accessToken}`);

    const options = {
        method: "GET",
        headers: headers
    };

    const response = await fetch(`https://graph.microsoft.com/v1.0${endpoint}`, options);
    if (!response.ok) {
        throw new Error(`MS Graph error ${response.status} on ${endpoint}`);
    }
    const data = await response.json();
    return data;
}

export type UserRole = 'superadmin' | 'admin' | 'owner';

let _cachedRole: UserRole | null = null;

export async function checkRole(accessToken: string): Promise<UserRole> {
    if (_cachedRole) {
        sessionStorage.setItem('__role_real', _cachedRole);
        return _cachedRole;
    }

    const superAdminGroupId = process.env.REACT_APP_SEC_SUPER_ADMIN;
    const adminGroupId = process.env.REACT_APP_SEC_ADMIN;
    try {
        // Follow pagination in case the user is in many groups
        let groups: any[] = [];
        let endpoint: string | null = '/me/transitiveMemberOf/microsoft.graph.group?$top=999';
        while (endpoint) {
            const data: any = await callMsGraph(accessToken, endpoint);
            if (!Array.isArray(data.value)) {
                throw new Error('Unexpected MS Graph response: missing value array');
            }
            groups = groups.concat(data.value);
            endpoint = data['@odata.nextLink']
                ? data['@odata.nextLink'].replace('https://graph.microsoft.com/v1.0', '')
                : null;
        }
        let role: UserRole = 'owner';
        if (groups.some((g: any) => g.id === superAdminGroupId)) role = 'superadmin';
        else if (groups.some((g: any) => g.id === adminGroupId)) role = 'admin';
        _cachedRole = role;
        sessionStorage.setItem('__role_real', role);
        return role;
    } catch (err) {
        // Do NOT cache failures as 'owner' — allow retry on next check
        console.error('checkRole failed, falling back to owner (not cached):', err);
        sessionStorage.setItem('__role_real', 'owner');
        return 'owner';
    }
}

// Backward compat — true for both admin and superadmin
export async function checkIsAdmin(accessToken: string): Promise<boolean> {
    const role = await checkRole(accessToken);
    return role === 'superadmin' || role === 'admin';
}
